export default __webpack_public_path__ + "static/983-0788b4a65857fecc41d3f265371fbfeb.gif";